import $ from 'jquery';
import 'jquery-validation';

$.validator.addMethod(
  'orgnr',
  function (value, element) {
    return (
      this.optional(element) || /^[0-9]{3}\s?[0-9]{3}\s?[0-9]{3}$/.test(value)
    );
  },
  'Orgnr'
);

$.validator.addClassRules({
  date: {
    date: false // conflicts with simple_form type: :date, which adds .date class to each date field
  }
});

function validateForms() {
  $('.validate-form').each(function () {
    $(this).validate({
      errorPlacement: function () {},
      highlight: function (element) {
        $(element).closest('.form-group').addClass('has-error');
      },
      unhighlight: function (element) {
        $(element).closest('.form-group').removeClass('has-error');
      }
    });
  });
}

document.addEventListener('turbolinks:load', validateForms);
document.addEventListener('ajax:success', validateForms);
